module.exports = __webpack_public_path__ + "img/chengpin.64b3c94b.jpg";